import { CL_PRODUCT_COPY } from "@/domains/manual-cl-page/cl-product-copy"

import { NavigationSubItem } from "../navigation-item"

export class ManualClLiquiditySubItem extends NavigationSubItem {
  readonly id = "manual-cl"
  readonly label = CL_PRODUCT_COPY.v1.shortName
  readonly href = "/liquidity/cl/v1"
  readonly iconName = "manual-icon"
  readonly isExternal = false
  readonly tabs = []
}

export class ManualClAllPoolsSubItem extends NavigationSubItem {
  readonly id = "manual-cl-all-pools"
  readonly label = CL_PRODUCT_COPY.v1.shortName
  readonly href = "/liquidity/cl/v1?view=all-pools"
  readonly iconName = "manual-icon"
  readonly isExternal = false
  readonly tabs = []
}

export class ManualClMyPositionsSubItem extends NavigationSubItem {
  readonly id = "manual-cl-my-positions"
  readonly label = "My Positions"
  readonly href = "/liquidity/cl/v1?view=my-positions"
  readonly iconName = "manual-icon"
  readonly isExternal = false
  readonly tabs = []
}
